export default __webpack_public_path__ + "static/media/abcSlide.45acf5a1.png";